// src/components/operationCenter/widgets/token/overview/TwFundingTrendWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import FundingTrendCard from "@/components/tokenPage/overview/FundingTrendCard";

const TwFundingTrendWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["derivatives"]}>
        <FundingTrendCard ticker={config.ticker.toUpperCase()} />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwFundingTrendWidget;
